
import { useState } from "react";
import  './AlertTableQuery.css';
import ApiServices from "../../utils/apiServices";
import { useEffect } from "react";

function PubMedAlertTableQuery(props) {
    const [alertResp , setAlertResp] = useState([]);
    useEffect(()=>{
        setAlertResp(props.selectedAlert)
    },[props.selectedAlert])

    return (
        <div className="alert-container">
            <table className="alert-table">
                <tbody>
                    <tr>
                        <td className="label">Alert Name</td>
                        <td>{alertResp.search_name}</td>
                    </tr>
                    <tr>
                        <td className="label">Search Query</td>
                        <td>{alertResp.search_keyword}</td>
                        </tr>
                    <tr>
                        <td className="label top">Search Strategy</td>
                        <td>
                            {alertResp.query_expansion}
                        </td>
                    </tr>
                    <tr>
                        <td className="label">Alert Frequency</td>
                        <td>{alertResp.alert_frequency}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}
export default PubMedAlertTableQuery;